import { PistolIcon } from './PistolIcon';

/**
 * author: Michael Richins
 * id 34C9947D-5943-4C3E-9E7A-2CD95061222B
 * name pistol
 * version: 1.8.36
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/pistol.svg
 * tags
 */
export const GunIcon = PistolIcon;
export default GunIcon